module.exports = __webpack_public_path__ + "static/media/care_instructions.87bf5acd.jpg";